export const language = {
	title: 'Contact Info',
	body: 'body',
};
